import React from "react";
import ContactInfo from "../components/ContactInfo";
import ContactForm from "../components/ContactForm";
import { siteData } from "../data/siteData";

const Contact = () => {
  return (
    <div className="relative min-h-screen pt-20 pb-12 px-4">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{
          backgroundImage: "url('/hero/aero.jpg')", // Replace with your actual image path
        }}
      ></div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>

      {/* Content */}
      <div className="relative z-10 text-gray-100">
        {/* Page Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl lg:text-5xl font-extrabold text-white animate-fadeIn">
            Connect with Us
          </h1>
          <p className="mt-4 text-base lg:text-lg leading-relaxed text-gray-200 max-w-2xl mx-auto animate-fadeIn delay-200">
            Have questions or want to get in touch? Reach out to us anytime.
            <br />
            <span className="font-medium text-white">
              Office hours: {siteData.contact.office_hours}.
            </span>
          </p>
        </div>

        {/* Responsive Split Layout */}
        <div className="flex flex-col lg:flex-row gap-10 max-w-6xl mx-auto -mt-2">
          {/* Contact Info */}
          <div className="lg:w-1/2 w-full mb-10 lg:mb-0">
            <ContactInfo />
          </div>

          {/* Contact Form */}
          <div className="lg:w-1/2 w-full">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
